module.exports = __webpack_public_path__ + "static/our_traits_2x-52793750a46cc8aa13803ddf6b5080f2.png";